import React, { useState } from "react";
import { CHAINS } from "@/lib/api";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";

const TREASURY = "0x9cb8915C36050e787615e13eA9787B3654BE9A15";

export default function Donate() {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(TREASURY);
      setCopied(true);
      toast.success("Treasury copied. Send dust from any chain.");
      setTimeout(() => setCopied(false), 1800);
    } catch { toast.error("Copy failed."); }
  };

  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 py-10">
      <div className="text-xs uppercase tracking-widest text-[#FFC940]">cremate your dust</div>
      <h1 className="mt-2 font-display text-5xl sm:text-6xl font-black">burial rites <span className="ember-text">·</span> no refunds</h1>

      <p className="mt-5 text-base text-stone-300 leading-relaxed">
        Copy the treasury address below and send any dead-coin dust from any supported chain.
        That's it. Your tx is read onchain automatically — nothing else to log.
      </p>

      <section className="mt-8 rounded-xl border border-[#3A2E1C] bg-[#141008] p-6">
        <div className="text-xs uppercase tracking-widest text-stone-500">treasury wallet · all EVM chains</div>
        <div className="mt-2 font-display text-xl">one address · everything lives here</div>

        <div className="mt-5 rounded-md border border-[#FFAB00]/40 bg-[#0A0906] p-4 ember-glow">
          <div className="text-[10px] uppercase tracking-widest text-stone-500 mb-1">address</div>
          <div className="font-mono text-sm sm:text-base break-all text-[#FFC940]" data-testid="treasury-address-display">{TREASURY}</div>
          <button
            onClick={copy}
            data-testid="treasury-copy-btn"
            className="mt-4 inline-flex items-center gap-2 h-10 px-4 rounded-md bg-[#FFAB00] text-[#0A0906] font-semibold hover:bg-[#FFC940] transition-colors"
          >
            {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
            {copied ? "copied" : "copy address"}
          </button>
        </div>

        <div className="mt-6">
          <div className="text-xs uppercase tracking-widest text-stone-500 mb-3">supported chains</div>
          <div className="flex flex-wrap gap-2">
            {CHAINS.map((c) => (
              <span
                key={c.id}
                className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-[#3A2E1C] bg-[#1E1810] text-xs mono"
              >
                <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: c.color }} />
                {c.name}
              </span>
            ))}
          </div>
          <p className="mt-5 text-xs text-stone-500 leading-relaxed">
            For Solana, send to a treasury wallet published in the #treasury channel on launch.
            Non-EVM manual submissions are honored once the chain scanner goes live.
          </p>
        </div>
      </section>
    </div>
  );
}
